import React, { useState } from "react";
import AddImage from "../../Global Functions/addImage";
import { AddImageAll } from "../../Global Functions/addImage";
import toast from "react-hot-toast";

const MediaUploadPopup = ({ visible, onClose }) => {
    const [uploadedPhotoUrl, setUploadedPhotoUrl] = useState("");
    const [uploadedPhotoUrlAll, setUploadedPhotoUrlAll] = useState("");
    const [uploadedVideoUrl, setUploadedVideoUrl] = useState("");
    const [photoUploading, setPhotoUploading] = useState(false);
    const [photoUploadingAll, setPhotoUploadingAll] = useState(false);
    const [videoUploading, setVideoUploading] = useState(false);
    const [photoDownloading, setPhotoDownloading] = useState(false);
    const [photoDownloadingAll, setPhotoDownloadingAll] = useState(false);
    const [videoDownloading, setVideoDownloading] = useState(false);


    const handleMediaUpload = async (event, setUrl, setUploading) => {
        const uploadedFile = event.target.files[0];
        if (!uploadedFile) {
            toast.error("No file selected");
            return;
        }

        setUploading(true);
        const responseUrl = await AddImage(uploadedFile);
        setUploading(false);

        if (responseUrl) {
            setUrl(responseUrl);
        } else {
            toast.error("File upload failed");
        }
    };

    const handleMediaUploadAll = async (event, setUrl, setUploading) => {
        const uploadedFile = event.target.files[0];
        if (!uploadedFile) {
            toast.error("No file selected");
            return;
        }

        setPhotoUploadingAll(true);
        const responseUrl = await AddImageAll(uploadedFile);
        setPhotoUploadingAll(false);

        if (responseUrl) {
            setUrl(responseUrl);
        } else {
            toast.error("File upload failed");
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => toast.success("Copied to clipboard"))
            .catch(() => toast.error("Copy failed"));
    };

    const downloadFile = async (url, type, setDownloading) => {
        setDownloading(true);
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;

            const urlParts = url.split('/').filter(Boolean);
            const filename = urlParts[urlParts.length - 1] || `uploaded-${type}-${Date.now()}.${type === 'photo' ? 'jpg' : 'mp4'}`;
            link.download = filename;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} downloaded`);
        } catch (error) {
            toast.error("Download failed");
            console.error("Download error:", error);
        } finally {
            setDownloading(false);
        }
    };

    if (!visible) return null;

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backdropFilter: "blur(4px)"
        }}>
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "32px",
                maxWidth: "500px",
                width: "90%",
                maxHeight: "90vh",
                overflow: "auto",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)"
            }}>
                <h3 style={{
                    margin: "0 0 24px 0",
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#1a1a1a"
                }}>Upload Media</h3>

                {/* UPLOAD ALL MEDIAL */}
                <div style={{
                    marginBottom: "24px",
                    padding: "20px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    border: "2px dashed #e0e0e0"
                }}>
                    <label style={{
                        display: "block",
                        marginBottom: "12px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#333",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                    }}>📷 Upload ALL Medial</label>

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleMediaUploadAll(e, setUploadedPhotoUrlAll, setPhotoUploadingAll)}
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            fontSize: "14px",
                            cursor: "pointer"
                        }}
                        disabled={photoUploadingAll}
                    />

                    {photoUploadingAll && (
                        <div style={{
                            marginTop: "12px",
                            padding: "8px",
                            backgroundColor: "#e3f2fd",
                            borderRadius: "6px",
                            fontSize: "13px",
                            color: "#1976d2",
                            textAlign: "center"
                        }}>
                            Uploading...
                        </div>
                    )}

                    {uploadedPhotoUrlAll && (
                        <div style={{
                            marginTop: "12px",
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            flexWrap: "wrap"
                        }}>
                            <input
                                type="text"
                                value={uploadedPhotoUrlAll}
                                readOnly
                                style={{
                                    flexGrow: 1,
                                    padding: "10px",
                                    border: "1px solid #4caf50",
                                    borderRadius: "8px",
                                    fontSize: "13px",
                                    backgroundColor: "#f1f8f4",
                                    color: "#2e7d32",
                                    minWidth: "200px"
                                }}
                            />
                            <button
                                onClick={() => copyToClipboard(uploadedPhotoUrlAll)}
                                aria-label="Copy Photo URL"
                                style={{
                                    padding: "10px 12px",
                                    backgroundColor: "#4caf50",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    transition: "all 0.2s",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap"
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = "#45a049"}
                                onMouseLeave={(e) => e.target.style.backgroundColor = "#4caf50"}
                            >
                                📋 Copy
                            </button>
                            <button
                                onClick={() => downloadFile(uploadedPhotoUrlAll, 'photo', setPhotoDownloadingAll)}
                                aria-label="Download Photo"
                                disabled={photoDownloadingAll}
                                style={{
                                    padding: "10px 12px",
                                    backgroundColor: photoDownloadingAll ? "#ff9800" : "#ff9800",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: photoDownloadingAll ? "not-allowed" : "pointer",
                                    fontSize: "14px",
                                    transition: "all 0.2s",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                    opacity: photoDownloadingAll ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => {
                                    if (!photoDownloadingAll) e.target.style.backgroundColor = "#f57c00";
                                }}
                                onMouseLeave={(e) => {
                                    if (!photoDownloadingAll) e.target.style.backgroundColor = "#ff9800";
                                }}
                            >
                                {photoDownloadingAll ? "⏳ Downloading..." : "⬇️ Download"}
                            </button>
                        </div>
                    )}
                </div>

                {/* Photo Upload Section */}
                <div style={{
                    marginBottom: "24px",
                    padding: "20px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    border: "2px dashed #e0e0e0"
                }}>
                    <label style={{
                        display: "block",
                        marginBottom: "12px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#333",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                    }}>📷 Convert To WEBP</label>

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleMediaUpload(e, setUploadedPhotoUrl, setPhotoUploading)}
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            fontSize: "14px",
                            cursor: "pointer"
                        }}
                        disabled={photoUploading}
                    />

                    {photoUploading && (
                        <div style={{
                            marginTop: "12px",
                            padding: "8px",
                            backgroundColor: "#e3f2fd",
                            borderRadius: "6px",
                            fontSize: "13px",
                            color: "#1976d2",
                            textAlign: "center"
                        }}>
                            Uploading...
                        </div>
                    )}

                    {uploadedPhotoUrl && (
                        <div style={{
                            marginTop: "12px",
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            flexWrap: "wrap"
                        }}>
                            <input
                                type="text"
                                value={uploadedPhotoUrl}
                                readOnly
                                style={{
                                    flexGrow: 1,
                                    padding: "10px",
                                    border: "1px solid #4caf50",
                                    borderRadius: "8px",
                                    fontSize: "13px",
                                    backgroundColor: "#f1f8f4",
                                    color: "#2e7d32",
                                    minWidth: "200px"
                                }}
                            />
                            <button
                                onClick={() => copyToClipboard(uploadedPhotoUrl)}
                                aria-label="Copy Photo URL"
                                style={{
                                    padding: "10px 12px",
                                    backgroundColor: "#4caf50",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    transition: "all 0.2s",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap"
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = "#45a049"}
                                onMouseLeave={(e) => e.target.style.backgroundColor = "#4caf50"}
                            >
                                📋 Copy
                            </button>
                            <button
                                onClick={() => downloadFile(uploadedPhotoUrl, 'photo', setPhotoDownloading)}
                                aria-label="Download Photo"
                                disabled={photoDownloading}
                                style={{
                                    padding: "10px 12px",
                                    backgroundColor: photoDownloading ? "#ff9800" : "#ff9800",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: photoDownloading ? "not-allowed" : "pointer",
                                    fontSize: "14px",
                                    transition: "all 0.2s",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                    opacity: photoDownloading ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => {
                                    if (!photoDownloading) e.target.style.backgroundColor = "#f57c00";
                                }}
                                onMouseLeave={(e) => {
                                    if (!photoDownloading) e.target.style.backgroundColor = "#ff9800";
                                }}
                            >
                                {photoDownloading ? "⏳ Downloading..." : "⬇️ Download"}
                            </button>
                        </div>
                    )}
                </div>

                {/* Video Upload Section */}
                <div style={{
                    marginBottom: "24px",
                    padding: "20px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "12px",
                    border: "2px dashed #e0e0e0"
                }}>
                    <label style={{
                        display: "block",
                        marginBottom: "12px",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#333",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                    }}>🎥 Upload Video</label>

                    <input
                        type="file"
                        accept="video/*"
                        onChange={(e) => handleMediaUpload(e, setUploadedVideoUrl, setVideoUploading)}
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            fontSize: "14px",
                            cursor: "pointer"
                        }}
                        disabled={videoUploading}
                    />

                    {videoUploading && (
                        <div style={{
                            marginTop: "12px",
                            padding: "8px",
                            backgroundColor: "#e3f2fd",
                            borderRadius: "6px",
                            fontSize: "13px",
                            color: "#1976d2",
                            textAlign: "center"
                        }}>
                            Uploading...
                        </div>
                    )}

                    {uploadedVideoUrl && (
                        <div style={{
                            marginTop: "12px",
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            flexWrap: "wrap"
                        }}>
                            <input
                                type="text"
                                value={uploadedVideoUrl}
                                readOnly
                                style={{
                                    flexGrow: 1,
                                    padding: "10px",
                                    border: "1px solid #2196f3",
                                    borderRadius: "8px",
                                    fontSize: "13px",
                                    backgroundColor: "#e3f2fd",
                                    color: "#1565c0",
                                    minWidth: "200px"
                                }}
                            />
                            <button
                                onClick={() => copyToClipboard(uploadedVideoUrl)}
                                aria-label="Copy Video URL"
                                style={{
                                    padding: "10px 12px",
                                    backgroundColor: "#2196f3",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    transition: "all 0.2s",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap"
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = "#1976d2"}
                                onMouseLeave={(e) => e.target.style.backgroundColor = "#2196f3"}
                            >
                                📋 Copy
                            </button>
                            <button
                                onClick={() => downloadFile(uploadedVideoUrl, 'video', setVideoDownloading)}
                                aria-label="Download Video"
                                disabled={videoDownloading}
                                style={{
                                    padding: "10px 12px",
                                    backgroundColor: videoDownloading ? "#ff9800" : "#ff9800",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "8px",
                                    cursor: videoDownloading ? "not-allowed" : "pointer",
                                    fontSize: "14px",
                                    transition: "all 0.2s",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                    opacity: videoDownloading ? 0.7 : 1
                                }}
                                onMouseEnter={(e) => {
                                    if (!videoDownloading) e.target.style.backgroundColor = "#f57c00";
                                }}
                                onMouseLeave={(e) => {
                                    if (!videoDownloading) e.target.style.backgroundColor = "#ff9800";
                                }}
                            >
                                {videoDownloading ? "⏳ Downloading..." : "⬇️ Download"}
                            </button>
                        </div>
                    )}
                </div>

                {/* Close Button */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: "12px 32px",
                            backgroundColor: "black",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600",
                            transition: "all 0.2s"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#e0e0e0";
                            e.target.style.color = "black";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "black";
                            e.target.style.color = "white";
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MediaUploadPopup;
